import angular from 'angular';

export const viewsModule = angular.module(
  'portainer.edge.react.views',
  []
).name;
